import { useCallback, useMemo } from 'react'
import { Standing } from 'types'
import { useSchedulesLink } from '../../hooks/useSchedulesLink'
import * as Styled from './StandingsTableRow.styled'

export function StandingsTableRow({ standing, index }: { standing: Standing; index: number }) {
  const winPercentage = useMemo(() => {
    if (standing.winPercentage === -1) {
      return 'N/A'
    }

    return Number.isInteger(standing.winPercentage)
      ? standing.winPercentage
      : standing.winPercentage.toFixed(3)
  }, [])

  const getStandingsLabel = useCallback((won: number, lose: number, tie: number) => {
    const tieLabel = tie ? ` - ${tie}` : ''
    return `${won} - ${lose}${tieLabel}`
  }, [])

  const homeStandings = useMemo(() => {
    const { homeWon, homeLose, homeTie } = standing
    return getStandingsLabel(homeWon, homeLose, homeTie)
  }, [getStandingsLabel, standing])

  const awayStandings = useMemo(() => {
    const { awayWon, awayLose, awayTie } = standing
    return getStandingsLabel(awayWon, awayLose, awayTie)
  }, [getStandingsLabel, standing])

  const { schedulesUrl } = useSchedulesLink(
    standing.stateId,
    standing.districtId,
    standing.id,
    standing.sportId,
  )

  const handleClickStanding = useCallback(() => {
    const newTab = window.open(schedulesUrl, '_blank')
    if (newTab) {
      newTab.focus()
    }
  }, [schedulesUrl])

  return (
    <Styled.TR onClick={handleClickStanding}>
      <Styled.TD>
        <Styled.RowIndex>{index + 1}</Styled.RowIndex>
      </Styled.TD>
      <Styled.TD>
        <Styled.School>
          {standing.imgUrl && <Styled.SchoolAvatar src={standing.imgUrl} />}
          <Styled.SchoolName>{standing.shortName || standing.name}</Styled.SchoolName>
        </Styled.School>
      </Styled.TD>
      <Styled.TD>{standing.won}</Styled.TD>
      <Styled.TD>{standing.lose}</Styled.TD>
      <Styled.TD>{standing.tie}</Styled.TD>
      <Styled.TD>{winPercentage}</Styled.TD>
      <Styled.TD>{homeStandings}</Styled.TD>
      <Styled.TD>{awayStandings}</Styled.TD>
      <Styled.TD>{standing.pf}</Styled.TD>
      <Styled.TD>{standing.pa}</Styled.TD>
      <Styled.TD>
        <Styled.Delta $value={standing.delta}>{standing.delta}</Styled.Delta>
      </Styled.TD>
      <Styled.TD>{standing.st}</Styled.TD>
    </Styled.TR>
  )
}
